<div mat-dialog-content class="select-list">
    <div *ngFor="let fli of financialLineItems">
        <mat-checkbox [(ngModel)]="fli.selected">
            {{ fli.name }}
        </mat-checkbox>
    </div>
</div>
<div mat-dialog-actions class="action-buttons">
    <aumico-button (click)="save()">{{ 'aumico_templates_save' | i18next  }}</aumico-button>
    <aumico-button (click)="closeDialog()">{{ 'aumico_templates_cancel' | i18next  }}</aumico-button>
</div>
